import { useEffect, useRef, useState } from "react"

import * as css from "./index.css"

export function useTruncateText() {
  const truncateRef = useRef<HTMLDivElement>(null)
  const truncateState = useState<boolean>(true)
  const [shouldTruncateText, setTruncateText] = truncateState

  useEffect(() => {
    if (truncateRef?.current) {
      // Check if the line clamping is active
      return setTruncateText(
        Number(truncateRef?.current?.clientHeight) > 0 &&
          truncateRef.current.scrollHeight > truncateRef?.current?.clientHeight
      )
    } else {
      setTruncateText(false)
    }
  }, [truncateRef.current])

  const className = css.truncatedText({ truncated: shouldTruncateText })

  return { ref: truncateRef, state: truncateState, className }
}
